import React, { useState, useEffect } from "react";
import { GRNPIN, REDPIN } from "../../images/images";

import {
  Marker,
  GoogleMap,
  withScriptjs,
  withGoogleMap,
  // DirectionsRenderer,
} from "react-google-maps";

function Map({ locationList }) {
  const {
    InfoBox,
  } = require("react-google-maps/lib/components/addons/InfoBox");
  const location = locationList;
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [props, setProps] = useState({
    lat: "",
    lng: "",
  });

  useEffect(() => {
    if (location?.location) {
      let keys = Object.keys(location?.location);
      let key = keys[0]; // Use first key instead of [1]

      const lat = location?.location[key]?.coords?.latitude;
      const lng = location?.location[key]?.coords?.longitude;

      setProps((p) => ({
        ...p,
        lat: lat,
        lng: lng,
      }));
    }
  }, [location]);


  return (
    <GoogleMap
      zoom={props?.lat && props?.lng ? 15 : 6}
      center={{
        lat: typeof props?.lat === 'number' ? props.lat : 6.465422,
        lng: typeof props?.lng === 'number' ? props.lng : 3.406448,
      }}
    >
      {Object.keys(location?.location ?? {}).map((key) => {
        const markerLat = location?.location[key].coords.latitude;
        const markerLng = location?.location[key].coords.longitude;

        return (
          <Marker
            key={key}
            position={{
              lat: markerLat,
              lng: markerLng,
            }}
            onClick={() => {
              setSelectedLocation(location.location[key]);
            }}
            icon={{
              url:
                (location?.location[key]?.order_status?.order_pending ?? 0) ===
                  0 &&
                  (location?.location[key]?.order_status?.order_accepted ?? 0) ===
                  0
                  ? `${GRNPIN}`
                  : `${REDPIN}`,
              anchor: new window.google.maps.Point(17, 46),
              scaledSize: new window.google.maps.Size(50, 50),
            }}
          />
        );
      })}

      {selectedLocation && (
        <InfoBox
          position={{
            lat: selectedLocation?.coords?.latitude,
            lng: selectedLocation?.coords?.longitude,
          }}
          onCloseClick={() => {
            setSelectedLocation(false);
          }}
        >
          <div className="info-box">
            <div className="info-text ">
              <div>
                <p>Courier Name: {selectedLocation?.courier_name}</p>
                <p>Status: {selectedLocation?.status}</p>
                <p>
                  Pending Orders:
                  {selectedLocation?.order_status?.order_pending}
                </p>
                <p>
                  Accepted Orders:
                  {selectedLocation?.order_status?.order_accepted}
                </p>
              </div>
            </div>
          </div>
        </InfoBox>
      )}
    </GoogleMap>
  );
}

const WrappedMap = withScriptjs(withGoogleMap(Map));

export default function AllRidersMap({ locationList }) {
  const google_key = process.env.REACT_APP_GOOGLE_WEB_API_KEY;
  return (
    <div style={{ height: "100vh", width: "104%" }}>
      <WrappedMap
        locationList={locationList}
        googleMapURL={`https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${google_key}`}
        loadingElement={<div style={{ height: "100%" }} />}
        containerElement={<div style={{ height: "100%" }} />}
        mapElement={<div style={{ height: "100%" }} />}
      />
    </div>
  );
}
